import { CheckPermissionsWrapper } from '@lib/permissions'
import { readAutomationsPermission } from '@features/automations/permissions'
import { NotPermitted } from '@components/Placeholders/NotPermitted'
import { createFileRoute, Outlet } from '@tanstack/react-router'

const AutomationsRoute = () => (
  <CheckPermissionsWrapper
    permissions={[readAutomationsPermission]}
    failureComponent={<NotPermitted />}
  >
    <Outlet />
  </CheckPermissionsWrapper>
)

export const Route = createFileRoute('/_auth/o/$orgId/automations')({
  component: AutomationsRoute,
  loader: () => ({
    crumb: 'Automations',
  }),
})
